import * as actionTypes from '../actions/actionTypes';

const initialState = {
    loading: true
}

const sectionReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.LOADINGSECTION:
         return {
             ...state,
             loading : action.val
         }
         default:
         return state;
    }
};

export default sectionReducer;